import { useMemo } from 'react';
import { useWellnessMetrics } from '../../../hooks/analytics/useWellnessAnalytics';
import { AnalyticsCard } from '../shared/AnalyticsCard';
import { palette } from '../shared/theme';
import { WellnessPrePostBarChart } from './WellnessPrePostBarChart';
import { WellnessFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';
import { formatWellnessExportData } from './wellnessUtils';
import { MetricTooltip } from './MetricTooltip';

interface WellnessPrePostCardProps {
  filters: WellnessFilter;
}

export function WellnessPrePostCard({ filters }: WellnessPrePostCardProps) {
  const { data, isLoading, isError, error } = useWellnessMetrics(filters);

  const exportData = useMemo(() => formatWellnessExportData(data || null), [data]);

  if (isError) return null;
  const accent = palette.indigo;
  return (
    <AnalyticsCard
      title="Pre vs Post Wellness Metrics"
      headerActions={<MetricTooltip metricKey="pleasant" />}
      isLoading={isLoading}
      error={error}
      exportData={exportData}
      exportFileName="wellness-pre-post"
      accent={accent}
    >
      <div className="mb-2 hidden text-xs italic text-[var(--anl-text-muted)] sm:block">
        Hover chart bars for questionnaire details
      </div>
      <WellnessPrePostBarChart data={data || null} height={350} />
    </AnalyticsCard>
  );
}
